import WoayClient from './main';
import $ from 'cash-dom';

function WoayCore(Options, game, eventBus, soundObj) {
    const client = new WoayClient(Options, eventBus, soundObj);
    const {
        html,
        reward,
        auth,
        helper,
        sound,
        api
    } = client;
    const {
        Wheel,
        SETTINGS
    } = Options;
    let clicked = false;
    let isEnoughPointReward = false;
    let quickScheme = Options.Wheel.scheme;
    let pointReward = 0;
    const verifyLoginDone = client.verifyLoginDone.bind(client);
    const updateInfoAfterLogin = client.updateInfoAfterLogin.bind(client);
    const loginMethod = Options.Wheel.login_method;
    html.injectHtml(Options);
    html.add3rdPartyLib();
    auth.checkLoginWithManychat(verifyLoginDone);
    auth.checkAuthParam(verifyLoginDone);
    if (loginMethod === 'haravan_order') {
        auth.checkLoginWithHaravan();
    }
    if (loginMethod === 'sapo_order') {
        auth.checkLoginWithSapo();
    }

    async function start() {
        console.log('woay start');
        // Kiểm tra login
        if (!reward.hasLogin) {
            console.log('not login yet');
            return client.auth.loginHandler(Wheel);
        }

        if (!reward.isAwading()) {
            startErrorHandler();
        }

        if (reward.isOutOfTurn() && !Options.Wheel.is_test_mode) {
            console.log('is out of turn');
            html.getModalOutOfTurn(Options, SETTINGS);
            eventBus.emit('outOfTurn');
            return;
        }

        let turn = reward.getRemainTurnCount();
        //claim nếu còn lượt chơi
        if (turn) {
            ('con luot');
            await reward.claimReward();
            reward.updateTurnCount();
        }
        if (Wheel.game_type == 'flipcard' || Wheel.game_type == 'matching') {
            if (isOutOfTurn()) return;
            console.log('OK - Lets go');
            return game.theGame.scene.play.startGame();
        }

        if (Wheel.game_type == 'li_xi' || Wheel.game_type == 'flying_gift') {
            if (isOutOfTurn()) return;
            sound.stopEffect('background_audio');
            var currentReward = reward.currentReward;
            console.log('currentReward', currentReward);
            return game.rollToSku(currentReward.sku);
        }

        if (Wheel.game_type == 'wheel') {
            sound.playEffect("rolling_audio");
            return reward.award(theReward => {
                game.theWheel.rollToSku(theReward.sku);
            });
        }
    }

    function isOutOfTurn() {
        if (reward.isOutOfTurn()) {
            console.log('het luot');
            html.getModalOutOfTurn(Options, SETTINGS)
            return true;
        }
        return false;
    }

    function startErrorHandler() {
        if (reward.error = 'IS_AWARDING') {
            vanillaToast.warning('Vui lòng đợi api awarding', {
                duration: 2000,
                fadeDuration: 200
            })
        }
    }

    // Handle login buttons
    auth.handleLoginButtons(verifyLoginDone, updateInfoAfterLogin);

    //MAIN LOGIC

    eventBus.on("wheel-stop", async function () {
        var r = reward.currentReward;
        if (r.code || r.sku == "BADLUCK") {
            reward.updateTurnCount();
            sound.stopEffect("rolling_audio");
            sound.playEffect("award_audio");
            return reward.congratulate(r.sku !== "BADLUCK", Options.is_popup);
        }
    });


    const LOGIN_METHOD_NO_AUTO_FILL = ['no_auth', 'password', 'play_code'];
    eventBus.on('login-done', function () {
        const login_method = Wheel.login_method;
        const userInfo = client.getUserInfo();
        const shouldAutoFill = !LOGIN_METHOD_NO_AUTO_FILL.includes(login_method);
        if (Wheel.game_type == 'flipcard' || Wheel.game_type == 'matching') {
            reward.updateTurnCount = () => {
                const turn = reward.getRemainTurnCount();
                game.theGame.updateTurn(turn);
            }
        }
        if (auth.loginBeforeInfoForm(Wheel)) {
            if (shouldAutoFill) {
                console.log('formAutoFill', {
                    userInfo
                })
                helper.formAutoFill(userInfo);
            }
            if (!auth.isUserEnoughData(userInfo)) {
                console.log('show modal woay userinfo');
                html.pushModal('modal-woay-userinfo');
            }
        }
    })

    $(document).on('click', '.btn-check-reward', function () {
        if (Wheel.game_type == 'wheel' && game.checkSpinning()) return;
        if (Wheel.game_type == 'li_xi' && game.isPicking()) return;
        html.closeAllModal();
        reward.checkRewardList();
    });

    $('.btn-woay, .bigButton, .btn-play')
        .off('click')
        .on('click', function () {
            if (Wheel.game_type == 'wheel' && game.checkSpinning()) return;
            if (Wheel.game_type == 'li_xi' && game.isPicking()) return;
            start();
        });

    //FLOW GAME LIXI + FLYING_GIFT

    eventBus.on('needToConfirm', function () {
        console.log('show popup confirm');
        sound.stopEffect('random_audio');
        // if (clicked) return;
        // clicked = true;
        setTimeout(function () {
            html.getModalConfirm(Options, SETTINGS)
        }, 200)
    });

    eventBus.on('cardWaiting', function () {
        console.log('on cardWaiting');
        clicked = true;
        start();
    })

    eventBus.on('startRandom', function () {
        sound.playEffect("random_audio");
    })

    eventBus.on('endRandom', function () {
        sound.stopEffect("random_audio");
    })

    eventBus.on('modal-after-show', function () {
        clicked = false;
    })

    $(document).on("click", "#w-confirm-cancel-btn", function () {
        html.closeAllModal();
    });

    $(document).on('click', '#w-confirm-submit-btn', function () {
        console.log('on click btn submit');
        reward.award()
            .then(function () {
                html.closeAllModal();
                const rewardIndex = game.getRewardIndex(reward.currentReward, Options);
                // console.log('rewardIndex', rewardIndex);
                game.activeCurrentCard(rewardIndex);
            })
    })

    //FLOW GAME FLIPCARD + MATCHING

    async function sendPoint(score, r, timeEnd) {
        try {
            var timePlay = Options.Wheel.design.TIME - timeEnd;
            console.log('timePlay1', timePlay);
            timePlay = Math.min(1000, timePlay);
            timePlay = Math.max(0, timePlay);
            console.log('timePlay2', timePlay);
            console.log('rewardId', r.reward_id);
            var payload = {
                reward_id: r.reward_id,
                point: score,
            }
            if (Number.isInteger(timePlay)) {
                Object.assign(payload, {
                    played_time: timePlay
                })
            }
            console.log('payload', payload);
            await api.createPoint(payload)
                .then(function (resp) {
                    console.log('create success', {
                        resp: resp
                    });
                })
            html.getPointsModal(Options, SETTINGS, score, isEnoughPointReward);
            eventBus.emit('award-done');
            $('.btn-play').css('pointer-events', 'unset');
            game.theGame.scene.play.resetGame();
            sound.playEffect('complete_stage_audio');
        } catch (e) {
            client.checkError(e);
        }
    }

    eventBus.on('start', function () {
        console.log('call start event');
        start();
    })
    eventBus.on('click-card', function () {
        sound.playEffect('pick_card_audio');
    })
    eventBus.on('fail-card', function () {
        sound.playEffect('fail_card_audio');
    })
    eventBus.on('same-card', function () {
        console.log('play music');
        sound.playEffect('same_card_audio');
    })

    eventBus.on('cancel-award', async function (score, timeEnd) {
        console.log('đã chơi xong game', score);
        var r = reward.currentReward;
        if (quickScheme == 'quick') {
            pointReward = Options.Wheel.design.POINT_REWARD || Options.Wheel.rules.POINT_REWARD;
            console.log('scheme là quick');
            if (!pointReward) {
                console.log('set mặc định pointReward');
                pointReward = 0;
            }
            console.log('pointReward', pointReward);
            if (score >= pointReward) {
                console.log('case trúng quà');
                isEnoughPointReward = true;
                await reward.award();
            } else if (score < pointReward) {
                await reward.cancelAward();
            }
        } else {
            await reward.cancelAward();
        }
        sendPoint(score, r, timeEnd);
    })

    eventBus.on('endGame', async function (score, timeEnd) {
        console.log('đã chơi xong game', score);
        var r = reward.currentReward;
        if (quickScheme == 'quick') {
            console.log('scheme là quick');
            pointReward = Options.Wheel.design.POINT_REWARD || Options.Wheel.rules.POINT_REWARD;
            if (!pointReward) {
                console.log('set mặc định pointReward');
                pointReward = 0;
            }
            console.log('pointReward', pointReward);
            if (score >= pointReward) {
                console.log('case trúng quà');
                isEnoughPointReward = true;
                await reward.award();
            } else if (score < pointReward) {
                await reward.cancelAward();
            }
        } else {
            await reward.award();
        }
        sendPoint(score, r, timeEnd);
    })

    $(document).on('click', '#w-submit-award', function () {
        html.closeAllModal();
        var r = reward.currentReward;
        if (r.code || r.sku == "BADLUCK") {
            reward.updateTurnCount();
            return reward.congratulate(r.sku !== "BADLUCK", Options.is_popup);
        }
    })

    $(document).on('click', '#w-play-again', function () {
        html.closeAllModal();
        start();
    })

    return {
        start,
        $,
        client,
        verifyLoginDone
    }
}

window.WoayCore = WoayCore;